<div class="shift-time-input position-relative">
  <div class="input-group input-group-sm">
    <input
      type="text"
      class="form-control text-center shift-time-input-control"
      [disabled]="disabled"
      [placeholder]="placeholder"
      [ngModel]="value"
      (ngModelChange)="onInputChange($event)"
      (focus)="onInputFocus()"
      (blur)="onInputBlur()"
      (keydown)="onInputKeydown($event)"
      role="combobox"
      aria-autocomplete="list"
      [attr.aria-expanded]="isOpen"
      [attr.aria-controls]="listboxId"
      [attr.aria-activedescendant]="activeDescendantId"
    />

    <button
      type="button"
      class="btn shift-time-caret-btn"
      [disabled]="disabled"
      (click)="onToggleDropdown($event)"
      aria-label="Toggle shift time presets"
      [attr.aria-expanded]="isOpen"
      [attr.aria-controls]="listboxId"
    >
      <i class="bi bi-chevron-down" [class.rotate-icon]="isOpen"></i>
    </button>
  </div>

  <div
    *ngIf="isOpen"
    class="dropdown-menu show w-100 shift-time-dropdown"
    [id]="listboxId"
    role="listbox"
  >
    <ng-container *ngIf="filteredPresets.length; else noPresetResults">
      <button
        *ngFor="let preset of filteredPresets; let i = index"
        type="button"
        class="dropdown-item shift-time-option"
        [id]="getOptionId(i)"
        role="option"
        [class.active]="isOptionHighlighted(i)"
        [class.current-value]="isCurrentValueOption(preset)"
        [attr.aria-selected]="isOptionHighlighted(i)"
        (mousedown)="onOptionMouseDown($event)"
        (click)="onOptionClick($event, preset)"
      >
        {{ preset }}
      </button>
    </ng-container>

    <ng-template #noPresetResults>
      <div class="dropdown-item-text text-muted small">
        No preset matches. Press Enter to keep your custom value.
      </div>
    </ng-template>
  </div>
</div>
